export default __webpack_public_path__ + "static/media/success.ce9b18b9.svg";